import { useRouter } from 'next/router'
import { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { CircleButton, Icon, Tooltip, useWindowSize } from '@moneymade/moneymade-ui'
import copy from 'copy-to-clipboard'

import { ROUTES } from 'static/menusConstants'
import { isBrowser } from 'utils'
// import PlatformFavorite from 'components/ui/PlatformFavorite/PlatformFavoriteContainer'
import styles from './TopActions.module.scss'

const TopActions = ({ currentInvestment: { name } }) => {
  const { screenWidth } = useWindowSize()
  const { push, back } = useRouter()

  const urlPlatform = useMemo(() => (isBrowser() ? window.location.href : ''), [])

  const [copySuccess, setCopySuccess] = useState(false)

  const handleShareDesktopClick = event => {
    event.stopPropagation()

    if (urlPlatform) {
      copy(urlPlatform)
      setCopySuccess(true)
      setTimeout(() => setCopySuccess(false), 1200)
    }
  }

  const handleShareMobileClick = async event => {
    event.stopPropagation()(
      urlPlatform &&
        (await navigator.share({
          title: `Moneymade platform ${name}`,
          url: urlPlatform
        }))
    )

    setCopySuccess(true)
  }

  return (
    <div className={styles.TopActions}>
      <CircleButton
        color="dark"
        layout="outlined"
        size={screenWidth < 600 ? 'sm' : 'md'}
        icon={<Icon icon="icon-point-left" size={14} />}
        onClick={() => (window.prevRoute ? back() : push(`/${ROUTES.discover}`))}
      />

      <div className={styles.RightSide}>
        <Tooltip tooltipText={copySuccess ? 'Copied!' : 'Click to copy profile URL to share'}>
          <CircleButton
            color="dark"
            layout="outlined"
            size={screenWidth < 600 ? 'sm' : 'md'}
            icon={<Icon icon="icon-share" />}
            onClick={screenWidth < 961 ? handleShareMobileClick : handleShareDesktopClick}
          />
        </Tooltip>
      </div>
    </div>
  )
}

TopActions.propTypes = {
  currentInvestment: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })
}

TopActions.defaultProps = {
  currentInvestment: {
    id: '',
    name: ''
  }
}

export default TopActions
